import {Language} from '@/model/src/values/dv-7';
import {DomainValueReference} from '@/model/types';

export const mapClientLanguageToDomainValue = (language?: string | null): DomainValueReference | null => {
  switch (language) {
    case 'F':
      return {$ref: Language.FRENCH};
    case 'E':
      return {$ref: Language.ENGLISH};
    default:
      return null;
  }
};
